import i18n from '@/plugins/i18n';
import { SortOrder } from '@/utils/enums/sortOrder';
import {
  ApplicationOverviewHeader,
  BrowserOverviewHeader,
  MobileOverviewHeader,
  VMOverviewHeader,
} from '@/utils/enums/headerType';
import { HeaderKeys } from '@/components/VM/vm.types';
import { MetricType, Capability, ScopeType } from '@/utils/enums/metricType';
import {
  CAPABILITY_MOBILE,
  CAPABILITY_APM,
  CAPABILITY_VM,
} from '@/utils/constants';
import mobile from '@/utils/templates/mobile.template';

/**
 * Headers for diffrent overview table
 */

const VMOverviewTableHeaders = () => [
  {
    key: HeaderKeys.serviceName,
    name: i18n.global.t('vmgroups'),
    width: '27%',
    sortable: true,
    routable: true,
    isEllipsisReq: true,
    style: {
      height: '5rem',
    },
  },
  {
    key: HeaderKeys.cpu,
    name: i18n.global.t('cpuUsage'),
    sortable: true,
    width: '15%',
    dataType: 'float',
    routable: true,
    style: {
      padding: '0',
      height: '5rem',
    },
  },
  {
    key: HeaderKeys.ram,
    name: i18n.global.t('ramAvailable'),
    sortable: true,
    width: '21%',
    dataType: 'float',
    routable: true,
    style: {
      padding: '0',
      height: '5rem',
    },
  },
  {
    key: HeaderKeys.storage,
    name: i18n.global.t('storageAvailable'),
    sortable: true,
    width: '24%',
    dataType: 'float',
    routable: true,
    style: {
      padding: '0',
      height: '5rem',
    },
  },
  {
    key: HeaderKeys.availability,
    name: i18n.global.t('availability'),
    sortable: true,
    width: '13%',
    routable: true,
    style: {
      padding: '0rem',
      height: '5rem',
    },
  },
];

const ApplicationOverviewTableHeader = () => [
  {
    key: ApplicationOverviewHeader.SERVICE_NAME,
    name: i18n.global.t('name'),
    width: '24%',
    sortable: true,
    routable: true,
    baseRoute: '/apm/dashboard/service',
    isEllipsisReq: true,
    style: {
      height: '5rem',
    },
  },
  {
    key: ApplicationOverviewHeader.APM_INFRA,
    name: '',
    width: '7%',
    routable: true,
    baseRoute: '/apm/dashboard/infra/instances',
    isEllipsisReq: true,
    style: {
      height: '5rem',
    },
  },
  {
    key: ApplicationOverviewHeader.TOTAL_ALERTS,
    name: i18n.global.t('alerts'),
    width: '19%',
    sortable: true,
    dataType: 'float',
    defaultOrder: SortOrder.DES,
    defaultSortBy: true,
    routable: true,
    baseRoute: '/alertsV2/generatedV2', // /alert/generated
    style: {
      height: '5rem',
    },
  },
  {
    key: ApplicationOverviewHeader.ERROR,
    name: i18n.global.t('errorsPercentage'),
    width: '18%',
    dataType: 'float',
    sortable: true,
    routable: true,
    baseRoute: '/apm/trace?status=Error', //Routing to trace with status
    style: {
      height: '5rem',
    },
  },
  {
    key: ApplicationOverviewHeader.APDEX,
    width: '12%',
    name: i18n.global.t('apdexTitle'),
    sortable: true,
    dataType: 'float',
    routable: false,
    style: {
      height: '5rem',
    },
  },
  {
    key: ApplicationOverviewHeader.CPM,
    name: i18n.global.t('callsPerMin'),
    width: '20%',
    dataType: 'float',
    sortable: true,
    routable: false,
    style: {
      height: '5rem',
    },
  },
];
export const DELETE = 'DELETE';
export const EDIT = 'EDIT';
const addDashboardIconItems = [
  {
    label: i18n.global.t('log.edit'),
    key: EDIT,
    icon: 'editFilled',
  },
  {
    label: i18n.global.t('log.delete'),
    key: DELETE,
    icon: 'deleteFilled',
  },
];
const BrowserMonitoringHeaders = () => [
  {
    key: BrowserOverviewHeader.SERVICE_NAME,
    name: i18n.global.t('name'),
    width: '20%',
    sortable: true,
    routable: true,
    baseRoute: '/browser/application',
    isEllipsisReq: true,
    style: {
      height: '5rem',
    },
  },
  {
    key: BrowserOverviewHeader.APDEX,
    width: '10%',
    name: i18n.global.t('apdexTitle'),
    sortable: true,
    dataType: 'float',
    routable: true,
    baseRoute: '/browser/application',
    style: {
      height: '5rem',
    },
  },
  {
    key: BrowserOverviewHeader.USERS_IMPACTED,
    width: '22%',
    name: i18n.global.t('usersImpacted'),
    sortable: true,
    dataType: 'float',
    routable: true,
    baseRoute: '/browser/application',
    style: {
      height: '5rem',
    },
  },
  {
    key: BrowserOverviewHeader.ERROR,
    width: '18%',
    name: i18n.global.t('errorCount'),
    sortable: true,
    dataType: 'float',
    routable: true,
    baseRoute: '/browser/errors',
    style: {
      height: '5rem',
    },
  },
  {
    key: BrowserOverviewHeader.RESP,
    width: '20%',
    name: i18n.global.t('loadTimeMS'),
    sortable: true,
    dataType: 'float',
    routable: true,
    baseRoute: '/browser/application',
    style: {
      height: '5rem',
    },
  },
  {
    key: BrowserOverviewHeader.CPM,
    name: 'CPM',
    width: '10%',
    dataType: 'float',
    sortable: true,
    routable: true,
    style: {
      height: '5rem',
    },
  },
];

const MobileMonitoringHeaders = () => [
  {
    key: MobileOverviewHeader.SERVICE_NAME,
    name: i18n.global.t('name'),
    width: '20%',
    sortable: true,
    routable: true,
    baseRoute: '/mobile',
    style: {
      height: '5rem',
    },
  },
  {
    key: MobileOverviewHeader.TOTAL_ALERTS,
    name: i18n.global.t('alerts'),
    width: '17%',
    sortable: true,
    dataType: 'float',
    defaultOrder: SortOrder.DES,
    defaultSortBy: true,
    routable: true,
    baseRoute: '/alertsV2/generatedV2?capability=mobile', // /alert/generated?capability=mobile
    style: {
      height: '5rem',
    },
  },
  {
    key: MobileOverviewHeader.CRASHCOUNT,
    width: '18%',
    name: i18n.global.t('crashes'),
    sortable: true,
    dataType: 'float',
    routable: true,
    baseRoute: '/mobile/kpis/crashes/',
    style: {
      height: '5rem',
    },
  },
  {
    key: MobileOverviewHeader.ERROR,
    width: '20%',
    name: i18n.global.t('errorRate'),
    sortable: true,
    dataType: 'float',
    routable: true,
    baseRoute: '/mobile/kpis/performance/',
    style: {
      height: '5rem',
    },
  },
  {
    key: MobileOverviewHeader.RESP,
    width: '25%',
    name: i18n.global.t('avgHTTPResTime'),
    sortable: true,
    dataType: 'float',
    routable: true,
    baseRoute: '/mobile/kpis/performance/',
    style: {
      height: '5rem',
    },
  },
];

/**
 * !IMPORTANT
 * This is basic mapping on which all things are mapped
 */

const OverviewTableName = {
  VM: 'VM monitoring',
  BM: 'Browser monitoring',
  APM: 'Application performance monitoring',
  MM: 'Mobile monitoring',
};

const translatedOverviewTableName = () => ({
  [OverviewTableName.VM]: i18n.global.t('vmMonitoring'),
  [OverviewTableName.BM]: i18n.global.t('browserMonitoring'),
  [OverviewTableName.APM]: i18n.global.t('apmOverview'),
  [OverviewTableName.MM]: i18n.global.t('mobileMonitoring'),
});

/**
 * ViewType and Capability Map
 */

const CapabilityMap = {
  [OverviewTableName.VM]: Capability.VM,
  [OverviewTableName.BM]: Capability.BROWSER,
  [OverviewTableName.APM]: Capability.APM,
  [OverviewTableName.MM]: Capability.MOBILE,
};
/**
 * ViewType and headers mapping
 */
const OverViewsHeaders = {
  [OverviewTableName.VM]: VMOverviewTableHeaders,
  [OverviewTableName.APM]: ApplicationOverviewTableHeader,
  [OverviewTableName.BM]: BrowserMonitoringHeaders,
  [OverviewTableName.MM]: MobileMonitoringHeaders,
};

/**
 *
 * @param {*} self //this value for component
 * @param {*} capability //current capability
 */

const getParamsByView = (self, capability, teamId) => {
  /**
   * For VM
   */
  const params = {
    condition: {
      keyword: self.keyword,
      filterCondition: {
        scope: ScopeType.SERVICE,
        metricType: self.metricType,
        order: self.sortOrder,
      },
      pagination: {
        pageNum: self.currentPage,
        pageSize: self.pageSize,
        needTotal: true,
      },
      duration: self.getDurationTime,
      serviceReq: {
        capability: capability,
        teamID: teamId,
      },
    },
  };
  switch (capability) {
    case Capability.APM:
      return {
        ...params,
        condition: {
          ...params.condition,
          serviceReq: {
            ...params.condition.serviceReq,
            checkCorrelation: true,
            correlatedCapability: 'V',
          },
        },
      };
    default:
      return params;
  }
};
/**
 * Sorting Condition Map by ViewType
 */
const sortingMap = {
  [OverviewTableName.VM]: {
    [VMOverviewHeader.SERVICE_NAME]: MetricType.NAME,
    [VMOverviewHeader.CPU]: MetricType.CPU,
    [VMOverviewHeader.RAM]: MetricType.RAM,
    [VMOverviewHeader.STORAGE]: MetricType.STORAGE,
    [VMOverviewHeader.NETWORK]: MetricType.NETWORK,
    [VMOverviewHeader.AVAILABILITY]: MetricType.AVAILABILITY,
  },
  [OverviewTableName.BM]: {
    [BrowserOverviewHeader.SERVICE_NAME]: MetricType.NAME,
    [BrowserOverviewHeader.TOTAL_ALERTS]: MetricType.ALERTS,
    [BrowserOverviewHeader.RESP]: MetricType.RESP,

    [BrowserOverviewHeader.APDEX]: MetricType.APDEX,

    [BrowserOverviewHeader.CPM]: MetricType.CALLS,
    [BrowserOverviewHeader.USERS_IMPACTED]: MetricType.USERS,
    [BrowserOverviewHeader.ERROR]: MetricType.ERROR,
  },
  [OverviewTableName.APM]: {
    [ApplicationOverviewHeader.SERVICE_NAME]: MetricType.NAME,
    [ApplicationOverviewHeader.TOTAL_ALERTS]: MetricType.ALERTS,
    [ApplicationOverviewHeader.ERROR]: MetricType.ERROR,

    [ApplicationOverviewHeader.CPM]: MetricType.CALLS,
    [ApplicationOverviewHeader.APDEX]: MetricType.APDEX,
  },
  [OverviewTableName.MM]: {
    [MobileOverviewHeader.SERVICE_NAME]: MetricType.NAME,
    [MobileOverviewHeader.TOTAL_ALERTS]: MetricType.ALERTS,
    [MobileOverviewHeader.CRASHCOUNT]: MetricType.CRASHES,
    [MobileOverviewHeader.ERROR]: MetricType.ERROR,
    [MobileOverviewHeader.RESP]: MetricType.RESP,
  },
};
/**
 * ViewType and redirect path Map
 */
const redirectMap = {
  [OverviewTableName.VM]: 'vm',
  [OverviewTableName.BM]: 'browser',
  [OverviewTableName.APM]: 'dashboard',
  [OverviewTableName.MM]: 'mobile',
};
/**
 *
 * @param {*} self//this value of current compoenent
 * @param {*} viewName //type of view
 * @param {*} option //option payload from table component
 */
const redirectTo = (self, viewName, option, duration) => {
  /**
   * On redirect ,
   * All these three compoent call some actions
   * Based on type of view
   * We have again created a Map
   */

  const query = {
    id: option[HeaderKeys.serviceID],
  };
  const route = option.redirectTo
    ? { path: option.redirectTo, query }
    : {
        name: redirectMap[viewName],
        query,
      };
  /**
   * Finallly redirect it to path
   */

  self.$router.push(route);
};

const getSortingBy = (overviewType, orderBy) => {
  return sortingMap[overviewType][orderBy] || null;
};

const getSortMetric = (overviewType) => {
  switch (overviewType) {
    case OverviewTableName.VM:
      return MetricType.CPU;
    case OverviewTableName.APM:
      return MetricType.ALERTS;
    case OverviewTableName.BM:
      return MetricType.APDEX;
    case OverviewTableName.MM:
      return MetricType.ALERTS;
  }
};

function getDefaultPageProps() {
  return ['5', '10', '15'];
}

const defaultDashboards = [
  { name: 'Standard', id: 'default' },
  { name: 'Standard Beta', id: 'defaultBeta', isBeta: true },
];

const homepageLoaderConfigPara = { rows: 6, width: new Array(6).fill('100%') };

export {
  CapabilityMap,
  OverViewsHeaders,
  OverviewTableName,
  getParamsByView,
  getSortingBy,
  getSortMetric,
  redirectTo,
  translatedOverviewTableName,
  getDefaultPageProps,
  addDashboardIconItems,
  defaultDashboards,
  homepageLoaderConfigPara,
};
